(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/utils/constants.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/utils/constants.js');

'use strict';

const loginMethods = {
  bankid: {
    icon: 'bankid-neg',
    pnpIcon: 'bankid-promo',
    buttonText: 'Starta',
    methodName: 'BankID',
    hasManualButton: true,
    isFreja: false,
    param: 'b',
    appUrl: 'https://www.bankid.com/privat/skaffa-bankid/'
  },
  freja: {
    icon: 'freja-eid-vertical-neg',
    pnpIcon: 'freja-eid-vertical',
    buttonText: 'Starta',
    methodName: 'Freja eID',
    hasManualButton: true,
    isFreja: true,
    param: 'f',
    appUrl: 'https://frejaeid.com/skaffa-freja-eid/'
  }
};
const POST_MESSAGE_TYPES = {
  HEIGHT: 'height',
  SHOW_DIALOG: 'show-dialog',
  SHOW_DIALOG_RESOLVED: 'show-dialog-resolved',
  SHOW_DIALOG_EXTENDED: 'show-dialog-extended',
  SHOW_DIALOG_EXTENDED_RESOLVED: 'show-dialog-extended-resolved',
  PARENT_REDIRECT: 'parent-redirect',
  PARENT_RELOAD: 'parent-reload',
  FULLSCREEN: 'fullscreen',
  REMOVE_FULLSCREEN: 'remove-fullscreen',
  UPDATE_ONBOARDING_DATA: 'update-onboarding-data',
  SET_LOGIN_TYPE: 'set-login-type',
  UPDATE_PARENT_QUERYSTRING: 'update-parent-querystring',
  PARENT_QUERYSTRING_UPDATED: 'parent-querystring-updated',
  PARENT_ONBOARDING_DATA_UPDATED: 'parent-onboarding-data-updated',
  GET_PARAMS_FROM_URL: 'get-params-from-url',
  PARENT_TRACK_EVENT: 'parent-track-event',
  PARENT_TRACK_EVENT_RESOLVED: 'parent-track-event-resolved'
};
svs.iam_idp.constants = {
  loginMethods,
  POST_MESSAGE_TYPES
};

 })(window);